import React from 'react';
import PropTypes from 'prop-types';
import ErrorPopup from '../ErrorPopup';

import './style.scss';

const TextareaField = ({
  label,
  input,
  meta: {
    touched,
    error,
  },
}) => (
  <div className="field-base">
    <textarea className="field-base__input" {...input} placeholder={label} />
    {touched && error && <ErrorPopup text={error} />}
  </div>
);

TextareaField.propTypes = {
  label: PropTypes.string,

  input: PropTypes.shape({
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,

  meta: PropTypes.shape({
    touched: PropTypes.any,
    error: PropTypes.any,
  }).isRequired,
};

TextareaField.defaultProps = {
  label: '',
};

export default TextareaField;



// WEBPACK FOOTER //
// ./src/components/ui/Fields/TextareaField/index.js